import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { GeneralDialog } from 'sharedComponents/GeneralDialog';
import { IconInfoFilled } from 'svgIcons/MotionPortalIcons';
import colors from 'theme/_colors.scss';
import './style.scss';
import { disconnectEnvironmentSensor } from './actions';

const DisconnectEnvironmentSensorComponent = ({ isShowDisconnectEnvironmentSensorDialog, setIsShowDisconnectEnvironmentSensorDialog, gatewayID }) => {
    const { t: translate } = useTranslation();
    const dispatch = useDispatch();

    const content = <div className='disconnect-environment-sensor__content' id='disconnect-environment-sensor__content-id'>
        <p>{translate('ABB.Powertrain.Frontend.gatewayDisconnectEnvironmentSensorHeadingDescription')}</p>
    </div>;

    const getRefreshGatewayTitle = <h1 className='disconnect-environment-sensor__title' id='disconnect-environment-sensor__title-id'>
        <IconInfoFilled color={colors.primaryInfo} />
        <span className='disconnect-environment-sensor__title-text'>{translate('ABB.Powertrain.Frontend.gatewayDisconnectEnvironmentSensorTitle')}</span>
    </h1>;
    return <GeneralDialog
        show={isShowDisconnectEnvironmentSensorDialog}
        close={() => setIsShowDisconnectEnvironmentSensorDialog(false)}
        title={getRefreshGatewayTitle}
        id='disconnect-environment-sensor-dialog'
        dialogClassName='disconnect-environment-sensor__dialog'
        closeButton={true}
        cancelButtonProps={{
            text: translate('ABB.Powertrain.Frontend.cancelLabel'),
        }}
        acceptButtonProps={{
            text: translate('ABB.Powertrain.Frontend.DisconnectLabel'),
            onClick: () => {
                dispatch(disconnectEnvironmentSensor(gatewayID));
                setIsShowDisconnectEnvironmentSensorDialog(false);
            }
        }}
    >
        {content}
    </GeneralDialog>;
};

DisconnectEnvironmentSensorComponent.propTypes = {
    isShowDisconnectEnvironmentSensorDialog: PropTypes.bool,
    setIsShowDisconnectEnvironmentSensorDialog: PropTypes.func,
    gatewayID: PropTypes.number,
};

export default DisconnectEnvironmentSensorComponent;
